export const colourOptions = [
    { value: 'ocean', label: 'Ocean', color: '#00B8D9', isFixed: true },
    // { value: 'blue', label: 'Blue', color: '#0052CC', isDisabled: true },
    { value: 'purple', label: 'Purple', color: '#5243AA' },
    { value: 'red', label: 'Red', color: '#FF5630', isFixed: true },
    { value: 'orange', label: 'Orange', color: '#FF8B00' },
    { value: 'yellow', label: 'Yellow', color: '#FFC400' },
    { value: 'green', label: 'Green', color: '#36B37E' },
    { value: 'forest', label: 'Forest', color: '#00875A' },
    { value: 'slate', label: 'Slate', color: '#253858' },
    { value: 'silver', label: 'Silver', color: '#666666' },
  ];

export const sizeOption = [
    { value: '200*290', label: '200*290' },
    { value: '160*225', label: '160*225' },
    { value: '133*190', label: '133*190' },    
];

export const categoryOption = [
    { value: 'DNEVNI BORAVAK', label: 'DNEVNI BORAVAK' },
    { value: 'KUHINJA', label: 'KUHINJA' },
    { value: 'SPAVAĆA SOBA', label: 'SPAVAĆA SOBA' },
    { value: 'KUPATILO', label: 'KUPATILO' },
    { value: 'HODNIK', label: 'HODNIK' },
]
export const priceOption = [
   { value: '429', label: '429' },
   { value: '543', label: '543' },
   { value: '458', label: '458' },
]

export const collectionOption = [
    {value: 'OPERA', label: 'OPERA'},
    {value: 'MODERN COLLECTION', label: 'MODERN COLLECTION'},
    {value: 'DIZAYN', label: 'DIZAYN'},
    {value: 'PLAZA', label: 'PLAZA'},
    {value: 'ŠPAGASTI', label: 'ŠPAGASTI'},
    {value: 'BAMBOO', label: 'BAMBOO'},
    {value: 'FLORA', label: 'FLORA'},
    {value: 'WENICE', label: 'WENICE'},
    {value: 'HEREKE', label: 'HEREKE'},
    {value: 'LOTUS', label: 'LOTUS'},
    {value: 'SOFT', label: 'SOFT'},
    {value: 'IRAN COLLECTION', label: 'IRAN COLLECTION'},
    {value: 'ZARA', label: 'ZARA'},
    {value: 'SARAJ', label: 'SARAJ'},
    {value: 'SARAJ COLLECTION', label: 'SARAJ COLLECTION'}
]